import React from "react";
import { AlertTriangle, Ban } from "lucide-react";
import ModalShell from "../ModalShell";
import { deptName } from "../../utils/names";

const DeactivateModal = ({ styles, t, language, busy, dept, onClose, onConfirm }) => (
  <ModalShell
    styles={styles}
    t={t}
    busy={busy}
    onClose={onClose}
    maxWidth={460}
    title={t.deactivate}
    subtitle={deptName(dept, language)}
    footer={
      <>
        <button type="button" style={styles.btnSecondary(busy)} disabled={busy} onClick={onClose}>{t.cancel}</button>
        <button type="button" style={styles.btnDanger(busy)} disabled={busy} onClick={onConfirm}>
          <Ban size={16} />{t.deactivate}
        </button>
      </>
    }
  >
    <div style={styles.notice("warning")}>
      <AlertTriangle size={16} style={{ flexShrink: 0, marginTop: "3px" }} />
      <span>{t.deactivateConfirm}</span>
    </div>
  </ModalShell>
);

export default DeactivateModal;
